module.exports = __webpack_public_path__ + "media/images/favicon-e3005fd53ecb09040243ea6f0e323582.png";